/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { IProfessionals, ProfessionalsServices } from '../../services/api/professionals/ProfessionalsServices';

interface VAutoCompletProfissionalProps {
    uuidCompany: string | undefined;
    initialValue?: string;
    onUserChange: (selectUser: string) => void;
    error: boolean;
    userId?: string;
    name?: string;
    onOptionsLoaded?: (hasOptions: boolean) => void;
}

export const VAutoCompletProfissional: React.FC<VAutoCompletProfissionalProps> = ({
    uuidCompany,
    initialValue,
    onUserChange,
    error,
    userId: currentUserId,
    name,
    onOptionsLoaded
}) => {
    const [allProfessionals, setAllProfessionals] = useState<IProfessionals[]>([]);
    const [loading, setLoading] = useState(true);
    const [autocompleteInputValue, setAutocompleteInputValue] = useState('');

    const normalizedUserId = useMemo(() => {
        if (currentUserId === 'novo' || currentUserId === 'new') {
            return undefined;
        }
        return currentUserId;
    }, [currentUserId]);

    useEffect(() => {
        if (uuidCompany) {
            setLoading(true);
            ProfessionalsServices.getList(uuidCompany, 'uuid')
                .then((response) => {
                    if (response instanceof Error) {
                        setAllProfessionals([]);
                    } else {
                        setAllProfessionals(response);
                        if (onOptionsLoaded) {
                            onOptionsLoaded(response.length > 0);
                        }
                    }
                })
                .catch((error) => {
                    setAllProfessionals([]);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setAllProfessionals([]);
            setLoading(false);
        }
    }, [uuidCompany, onOptionsLoaded]);

    const filteredProfessionals = useMemo(() => {
        if (!normalizedUserId) {
            return allProfessionals;
        }
        return allProfessionals.filter(item => item.uuid !== normalizedUserId);
    }, [allProfessionals, normalizedUserId]);

    const selectedOption = useMemo(() => {
        if (initialValue && filteredProfessionals.length > 0) {
            return filteredProfessionals.find(item => item.uuid === initialValue) || null;
        }
        return null;
    }, [initialValue, filteredProfessionals]);

    const handleAutocompleteChange = (event: React.SyntheticEvent, newValue: IProfessionals | null) => {
        onUserChange(newValue ? newValue.uuid || '' : '');
    };

    return (
        <div>
            <Autocomplete
                options={filteredProfessionals}
                getOptionLabel={(option) => option.nome}
                isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
                value={selectedOption}
                onChange={handleAutocompleteChange}
                loading={loading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={name ? name : 'Superior'}
                        variant="outlined"
                        error={error}
                    />
                )}
            />
        </div>
    );
};